import React from "react";
import PropTypes from "prop-types";
import { Label, Input, FormFeedback } from "reactstrap";
import CountrySelect from "../../../Components/Common/CountrySelect";
import { getEffectiveValue } from "./fieldConfig";

const numericKeyPress = (event) => {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
};

// Generic grid renderer for the wizard's Identity/Contact/Address/Banking
// steps — driven entirely by a field-config array (see fieldConfig.js) so
// the same markup serves both buyer types instead of duplicating JSX per
// kind, the way the old NaturalClientForm/LegalClientForm split did.
const FieldsStep = ({ fields, validation }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "16px 18px",
    }}
  >
    {fields.map((field) => {
      const {
        key,
        label,
        placeholder,
        type,
        required,
        numericOnly,
        wide,
        sameAsField,
        sameAsToggleKey,
        sameAsLabel,
      } = field;
      const touched = validation.touched[key];
      const error = validation.errors[key];
      const invalid = !!(touched && error);
      const fieldLabel = label + (required ? " *" : "");
      const sameAsChecked = sameAsToggleKey ? !!validation.values[sameAsToggleKey] : false;
      const displayValue = getEffectiveValue(field, validation.values);

      return (
        <div key={key} style={wide ? { gridColumn: "1 / -1" } : undefined}>
          <div className="d-flex align-items-center justify-content-between">
            <Label htmlFor={`${key}-field`} className="form-label mb-0">
              {fieldLabel}
            </Label>
            {sameAsField && (
              <div className="form-check form-check-sm mb-2">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`${sameAsToggleKey}-field`}
                  checked={sameAsChecked}
                  onChange={(e) => validation.setFieldValue(sameAsToggleKey, e.target.checked)}
                />
                <label
                  className="form-check-label text-muted"
                  style={{ fontSize: 12 }}
                  htmlFor={`${sameAsToggleKey}-field`}
                >
                  {sameAsLabel}
                </label>
              </div>
            )}
          </div>
          {type === "country" ? (
            <>
              <CountrySelect validation={validation} fieldName={key} />
              {invalid && <div className="invalid-feedback d-block">{error}</div>}
            </>
          ) : (
            <>
              <Input
                name={key}
                id={`${key}-field`}
                className="form-control"
                placeholder={placeholder}
                type={type === "email" ? "email" : "text"}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                onKeyPress={numericOnly ? numericKeyPress : undefined}
                value={displayValue || ""}
                disabled={sameAsField ? sameAsChecked : undefined}
                invalid={invalid}
              />
              {invalid && <FormFeedback type="invalid">{error}</FormFeedback>}
            </>
          )}
        </div>
      );
    })}
  </div>
);

FieldsStep.propTypes = {
  fields: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired,
};

export default FieldsStep;
